module.exports = __webpack_public_path__ + "static/media/google-drive-pdf-file.b2bf0e82.svg";